<template>
  <div>
    <el-dialog :title="title" center :visible="true" :close-on-click-modal="false" :close-on-press-escape="false"
      :show-close="true" :before-close="onClose" :width="`${dialogWidth}px`">
      <el-tabs v-model="activeTabName" type="card">
        <el-tab-pane v-for="item in this.leaderboards" :key="item.label" :label="item.label" :name="item.label">
          <el-table :data="item.list" border :style="{ width: `${activeLeaderboardTableWidth}px` }" size="small"
            height="500px">
            <el-table-column v-for="column of item.columns" :key="column.fieldName" :label="column.label" align="center"
              :width="column.width">
              <template slot-scope="scope">
                <span v-if="column.bizType == 'uid'">
                  <a style="text-decoration: none" href="javascript:;"
                    @click="toRouterPlayerInfoPage(scope.row[column.fieldName])">
                    {{ scope.row[column.fieldName] }}</a></span>

                <span v-else>{{ scope.row[column.fieldName] }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

// 本弹窗名称
const DialogName = "LeaderboardDialog";

export default {
  data() {
    return {
      title: "",
      activeTabName: "战力排行榜",
      leaderboards: [],
    };
  },

  created() {
    let value = dialogutil.getData(DialogName);
    this.loadList(value.zoneId);
    this.title = value.zoneId + "区排行榜";
  },

  computed: {
    /**
     * 当前对话框的宽度
     */
    dialogWidth() {
      if (this.activeLeaderboard) {
        return 51 + this.activeLeaderboardTableWidth;
      }

      return 800;
    },

    /**
     * 当前展示的排行榜的表格的宽度
     */
    activeLeaderboardTableWidth() {
      let activeLeaderboard = this.activeLeaderboard;
      if (activeLeaderboard) {
        let tableWidth = 0;

        for (let column of activeLeaderboard.columns) {
          tableWidth += column.width;
        }

        tableWidth += 1;

        return tableWidth;
      }

      return 500;
    },

    /**
     * 当前展示的排行榜
     */
    activeLeaderboard() {
      if (this.activeTabName && this.leaderboards) {
        for (let e of this.leaderboards) {
          if (e.label == this.activeTabName) {
            return e;
          }
        }
      }

      return null;
    }
  },

  methods: {
    /**
     * 查询排行榜
     */
    async loadList(zoneId) {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getZoneLeaderboards`,
          {
            zoneId: zoneId,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }
      this.activeTabName = resData.data.defaultName;

      let listInResp = resData.data.leaderboards || [];

      this.leaderboards = listInResp;
    },
    /**
     * 跳转到玩家详情界面
     * @param {*}
     */
    toRouterPlayerInfoPage(value) {
      window.open(
        this.$router.resolve({
          path: "/console/player/playerlist",
          query: { uid: value, tab: "playerList" },
        }).href,
        "_blank"
      );
    },
    onClose(done) {
      // 关闭当前对话框
      dialogutil.close(DialogName);
    },
  },
};
</script>